module.exports = __webpack_public_path__ + "img/img_25.9bbb8afe.svg";